import type { ReactElement } from 'react';

import { HotLeadsPage as HotLeadsFeaturePage } from '../features/hot-leads/pages/HotLeadsPage.js';

export default function HotLeadsPage(): ReactElement {
  return <HotLeadsFeaturePage />;
}
